import ReactGA from 'react-ga4';

let initialized = false;

export const gaProvider = {
  init(apiKey) {
    if (!apiKey) { console.warn('[Analytics] Google Analytics key missing'); return; }
    ReactGA.initialize(apiKey, { gaOptions: { send_page_view: false } });
    initialized = true;
  },

  track(name, data) {
    if (!initialized) return;
    ReactGA.event(name, data);
  },

  identify(id, traits) {
    if (!initialized) return;
    ReactGA.set({ userId: id, ...traits });
  },

  isReady: () => initialized,
};
